export default {"src":"/_next/static/media/liquidity-pools.9b109576.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};